import { render, staticRenderFns } from "./FirmwareUpdateForm.vue?vue&type=template&id=97dcf676&scoped=true"
import script from "./FirmwareUpdateForm.vue?vue&type=script&lang=ts"
export * from "./FirmwareUpdateForm.vue?vue&type=script&lang=ts"
import style0 from "./FirmwareUpdateForm.vue?vue&type=style&index=0&id=97dcf676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dcf676",
  null
  
)

export default component.exports